import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path } from '../IconBase/IconBase'
function Catalog({ color = 'icon.primary', fill = 'transparent', ...props }) {
  return (
    <IconBase viewBox='0 0 22 19' {...props}>
      <Path
        d='M9 2.24365L7 1.24365V17.2437L9 16.2437'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
        fill='transparent'
      />
      <Path
        d='M3 2.24365L1 1.24365V17.2437L3 16.2437'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
        fill='transparent'
      />
      <Path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M21 14.2437L13 17.2437V1.24365L21 4.24365V14.2437Z'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
        fill={fill}
      />
    </IconBase>
  )
}

Catalog.propTypes = {
  color: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  fill: PropTypes.string,
}

export default Catalog
